var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { getCurrentInstance, camelize } from "vue";
function propsToCamelKeyProps(currentProps) {
  const props = {};
  for (const key in currentProps) {
    const camelKey = key.includes("-") ? camelize(key) : key;
    props[camelKey] = currentProps[key];
  }
  return props;
}
__name(propsToCamelKeyProps, "propsToCamelKeyProps");
function useRealProps() {
  var _a;
  const current = getCurrentInstance(), currentProps = ((_a = current == null ? void 0 : current.vnode) == null ? void 0 : _a.props) ?? {};
  return propsToCamelKeyProps(currentProps);
}
__name(useRealProps, "useRealProps");
export {
  propsToCamelKeyProps,
  useRealProps
};
//# sourceMappingURL=useRealProps.js.map
